import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import translations from './translations';

const STORAGE_KEY = 'liv-studio-lang';

const LanguageContext = createContext(null);

function detectLocale() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'ru') return stored;
  return navigator.language.startsWith('ru') ? 'ru' : 'en';
}

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState(() => detectLocale());

  const setLocale = (next) => {
    setLocaleState(next);
    localStorage.setItem(STORAGE_KEY, next);
  };

  const t = useMemo(() => {
    const dict = translations[locale];
    return (key) => {
      const value = key.split('.').reduce((obj, part) => obj?.[part], dict);
      return value ?? key;
    };
  }, [locale]);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo(
    () => ({ locale, setLocale, t }),
    [locale, t]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
